<template>
  <ButtonSquare :hoverExplanationText="$t('general__view__match')" :imgSource="imgSource" />
</template>

<script>
import ButtonSquare from '@/components/general/buttons/ButtonSquare/ButtonSquare.vue'

export default {
  name: 'SyncViewButton',
  components: {
    ButtonSquare
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    imgSource: {
      type: String,
      default: ''
    }
  }
}
</script>
